export default __webpack_public_path__ + "static/media/header-wallet.49051000.svg";